module.exports = __webpack_public_path__ + "img/logo-government-9.0df259aa.png";